module.exports = __webpack_public_path__ + "assets/img/Currency1.1b794acd.png";